import { NewsBlockTemplate } from "./news-block.template";

export default {
    title: "Website/Page Templates/Homepage/Homepage Blocks/News Block",
    render: NewsBlockTemplate.bind({}),
    parameters: {
        layout: "fullscreen",
    },
};

export const Default = {};
